<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-material-card icon="mdi-clipboard-text" title="Prospectos" class="px-5 py-3">
      <br>
      <Filtro_Table_Proyectos :proyectos="proyectosAux" :search="search" @changeSearch="onchangeSearch"
        @changeFilterTable="onChangeFilterTable" />
      <Table_Proyectos :proyectos="proyectosAux" :is-loading="isLoadingTable" :search="search"
        @editarProyecto="onEditarProyecto" @actualizarTable="onActualizarTable" />
    </base-material-card>

    <v-speed-dial v-model="fab" fixed bottom right absolute :open-on-hover="hover" :transition="transition">
      <template v-slot:activator>
        <v-btn v-if="$store.getters.hasPermission('Proyectos', 'Crear')" v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="red" @click="validarProyecto()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn v-if="$store.getters.hasPermission('Proyectos', 'Crear')" fab dark small color="green"
        @click="modalUploadExcel()">
        <v-icon>mdi-paperclip</v-icon>
      </v-btn>
    </v-speed-dial>

    <Registro_Proyecto :show.sync="showRegistroProyecto" :is-editar-proyecto="isEditarProyecto"
      :names-proyectos="namesProyectos" @actualizarTable="onActualizarTable" />

    <v-dialog v-model="showUpload" persistent width="600">
      <v-card>
        <v-card-text>
          <v-form ref="formUploadProspectos" lazy-validation @submit.prevent="uploadFile">
            <v-card-title class="pa-2">
              Subir Prospectos
              <v-spacer />
            </v-card-title>

            <v-file-input id="file" label="Archivo Excel" placeholder="Sube tu archivo" accept=".xlsx, .xls"
              :rules="[v => !!v || 'El archivo es obligatorio']" @change="previewFiles" />
            <v-btn v-if="$store.getters.hasPermission('Proyectos', 'Descargar')" color="primary" outlined class="mb-4"
              @click="downloadTemplate">
              Descargar formato Excel
            </v-btn>
            <v-divider class="my-4" />

            <v-progress-linear v-if="isLoadinguploadFile" :value="progressUploadFile" height="25" color="blue">
              <strong>{{ progressUploadFile.toFixed(0) }} %</strong>
            </v-progress-linear>

            <span v-if="isValid_file" class="warning--text">
              {{ error_file }}
            </span>

            <v-card-actions class="pa-2">
              <v-btn outlined @click="showUpload = false">Cerrar</v-btn>
              <v-spacer />
              <v-btn color="primary" :loading="isLoadinguploadFile" type="submit">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>


    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogGps" persistent max-width="500">
          <v-card>
            <v-progress-linear indeterminate color="green" />
            <v-card-title class="text-h5">
              Obtiendo información GPS <v-icon>mdi-cellphone-marker</v-icon>
            </v-card-title>
            <v-card-text>Por favor active su GPS de celular, tablet o laptop.</v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <search-proyect-component ref="validateProyect" @onSearchProyectSuccess="chargeEmptyProject" />
  </v-container>
</template>

<script>
import SearchProyectComponent from './componentes/SearchProyectComponent.vue'
import Registro_Proyecto from './componentes/RegistroProyecto.vue';
import Filtro_Table_Proyectos from './componentes/FiltrosTableProyectos.vue';
import Table_Proyectos from './componentes/TableProyectos.vue';
import { mapActions } from 'vuex'
import firebase from 'firebase'
import * as XLSX from 'xlsx';
const db = firebase.firestore()

export default {
  components: {
    SearchProyectComponent,
    Registro_Proyecto,
    Filtro_Table_Proyectos,
    Table_Proyectos,
  },
  data() {
    return {
      chargedProjects: false,
      dialogValidarProyecto: false,
      dialogGps: false,
      isEditarProyecto: {
        status: true,
        title: '',
        data: {
          codigo: '',
          latitud: '',
          longitud: '',
          nombre: '',
          direccion: '',
          distrito: '',
          tipo: '',
          categoria: '',
          estado: '',
          numeroPisos: '',
          numeroDepartamentos: '',
          etapa: '',
          fechaEntrega: '',
          inmobiliaria: '',
          constructora: '',
          proveedorActual: '',
          visitas: '',
          foto: '',
          fecha_creacion: '',
          fecha_edicion: '',
          anio: '',
        },
      },
      namesProyectos: [],
      proyectos: [],
      proyectosAux: [],
      showRegistroProyecto: '',
      showUpload: false,
      search: '',
      isLoadinguploadFile: false,
      progressUploadFile: 0,
      isLoadingTable: true,
      isValid_file: true,
      error_file: '',
      transition: 'slide-y-reverse-transition',
      hover: false,
      fab: false,
    }
  },
  watch: {
    '$store.state.userAuth'(user) {
      if (user) {
        /* console.log('[watch] userAuth disponible, cargando proyectos...') */
        this.getProyectos()
      }
    }
  },
  mounted() {
    if (this.$store.state.userAuth) {
      this.executeChargedProjects()
    } else {
      const unwatch = this.$watch('$store.state.userAuth', (user) => {
        if (user) {
          this.executeChargedProjects()
          unwatch()
        }
      })
    }
    this.getProspectadores()
  },
  methods: {
    ...mapActions(['setProspectadores']),
    executeChargedProjects() {
      if (!this.chargedProjects) {
        this.getProyectos()
        this.chargedProjects = true
      }
    },
    getProyectos() {
      /* console.log('[getProyectos] Iniciado') */

      this.isLoadingTable = true
      this.datos = []
      this.proyectos = []
      this.proyectosAux = []

      const puedeVerTodo = this.$store.getters.hasPermission('Proyectos', 'VerTodo')
      const userEmail = this.$store.state.userAuth.email || ''

      /* console.log('[getProyectos] Permiso VerTodo:', puedeVerTodo)
      console.log('[getProyectos] Email del usuario:', userEmail) */

      const query = db.collection('proyectos').where('fase', '==', 1)
      query.get()
        .then((querySnapshot) => {
          if (querySnapshot.empty) {
            /* console.log('[getProyectos] No se encontraron proyectos con fase 1.') */
          }

          querySnapshot.forEach((doc) => {
            const data = doc.data()

            const permitido = puedeVerTodo || data.prospector === userEmail
            /* console.log(`[getProyectos] Proyecto ${data.nombre} - permitido: ${permitido}`) */

            if (permitido) {
              const visitas = data.visitas !== undefined ? data.visitas.length : '0'

              const proyecto = {
                codigo: data.codigo,
                latitud: data.latitud,
                longitud: data.longitud,
                nombre: data.nombre,
                direccion: data.direccion,
                region: data.region,
                provincia: data.provincia,
                tipo: data.tipo,
                categoria: data.categoria,
                estadoNegociacion: data.estadoNegociacion,
                estado: data.estado,
                numeroPisos: data.numeroPisos,
                numeroDepartamentos: data.numeroDepartamentos,
                etapa: data.etapa,
                fechaEntrega: data.entrega,
                inmobiliaria: data.inmobiliaria,
                constructora: data.constructora,
                proveedorActual: data.proveedorActual,
                prospector: data.prospector,
                visitas: visitas,
                foto: data.foto,
                planos: data.planos,
                metrados: data.metrados,
                fechaCreacion: this.formatoFecha(data.fechaCreacion),
                fecha_edicion: '',
                anio: data.anio,
                usuario: data.usuario,
                dateFechaCotizacion: data.dateFechaCotizacion,
                dateFechaFacturacion: data.dateFechaFacturacion,
                tipoVivienda: data.tipoVivienda,
                ipv: data.ipv,
                cantidadPuertas: data.cantidadPuertas,
                montoPuertas: data.montoPuertas,
                montoCortafuego: data.montoCortafuego,
                reunion: data.reunion,
                tipoSistema: data.tipoSistema,
                tipoCliente: data.tipoCliente,
                medioContacto: data.medioContacto,
                posibilidadCierre: data.posibilidadCierre,
                quienGano: data.quienGano,
                razonPerdido: data.razonPerdido,
                comments: data.comments,
                rangoVivienda: data.rangoVivienda,
                proveedorActualAgrupado: data.proveedorActualAgrupado,
                asesor: data.asesor,
              }

              this.proyectos.push(proyecto)
            }
          })

          this.proyectosAux = this.proyectos.slice()
          /* console.log('[getProyectos] Total proyectos visibles:', this.proyectos.length) */
        })
        .catch((error) => {
          console.error('[getProyectos] Error al obtener proyectos:', error)
        })
        .finally(() => {
          this.isLoadingTable = false
          /* console.log('[getProyectos] Carga finalizada.') */
        })
    },
    getProspectadores() {
      const filteredProfiles = []
      this.prospectores = []
      /* console.log('[1] Iniciando búsqueda de prospectores...') */

      firebase.firestore().collection('perfiles').get().then((prospectoresSnapshot) => {
        prospectoresSnapshot.forEach((prospector) => {
          const data = prospector.data()
          if (
            data &&
            data.Proyectos &&
            data.Proyectos.Prospección === true
          ) {
            filteredProfiles.push(prospector.id)
            /* console.log(`[2] Perfil con Prospección activa encontrado: ${prospector.id}`) */
          }
        })
        /* console.log('[3] Perfiles filtrados:', filteredProfiles) */
        firebase.firestore().collection('users').get().then((usersSnapshot) => {
          usersSnapshot.forEach((user) => {
            const userData = user.data()
            if (filteredProfiles.includes(userData.perfil)) {
              this.prospectores.push(userData.email)
              /*  console.log(`[4] Usuario agregado: ${userData.email}`) */
            }
          })
          /* console.log('[5] Lista final de prospectores:', this.prospectores) */
          this.setProspectadores(this.prospectores)
          /* console.log('[6] Datos enviados al store: ',this.$store.state.prospectadores) */
        })
      })
    },
    onchangeSearch(data) {
      this.search = data
    },
    onChangeFilterTable(data) {
      let filtrados = this.proyectos.slice()

      if (data.selectProspector && data.selectProspector !== 'Todos') {
        filtrados = filtrados.filter(proyect => proyect.prospector === data.selectProspector)
      }

      if (data.selectDistrito && data.selectDistrito !== 'Todos') {
        filtrados = filtrados.filter(proyect => proyect.distrito === data.selectDistrito)
      }

      if (data.selectEtapa && data.selectEtapa !== 'Todos') {
        filtrados = filtrados.filter(proyect => proyect.etapa === data.selectEtapa)
      }

      if (data.selectEstadoNegociacion && data.selectEstadoNegociacion !== 'Todos') {
        filtrados = filtrados.filter(proyect => proyect.estadoNegociacion === data.selectEstadoNegociacion)
      }

      if (data.selectFechaEntrega && data.selectFechaEntrega !== 'Todos') {
        const selectedYear = data.selectFechaEntrega.toString()

        filtrados = filtrados.filter(proyect => {
          const splittedYear = proyect.fechaEntrega.split(' ')[1] // Ej. "2025"
          return splittedYear === selectedYear
        })
      }

      this.proyectosAux = filtrados
    },
    onEditarProyecto(data) {
      this.isEditarProyecto.data.codigo = data.codigo
      this.isEditarProyecto.data.latitud = data.latitud
      this.isEditarProyecto.data.longitud = data.longitud
      this.isEditarProyecto.data.nombre = data.nombre
      this.isEditarProyecto.data.direccion = data.direccion
      this.isEditarProyecto.data.region = data.region
      this.isEditarProyecto.data.provincia = data.provincia
      this.isEditarProyecto.data.tipo = data.tipo
      this.isEditarProyecto.data.categoria = data.categoria
      this.isEditarProyecto.data.estado = data.estado
      this.isEditarProyecto.data.numeroPisos = data.numeroPisos
      this.isEditarProyecto.data.numeroDepartamentos = data.numeroDepartamentos
      this.isEditarProyecto.data.etapa = data.etapa
      this.isEditarProyecto.data.estadoNegociacion = data.estadoNegociacion
      this.isEditarProyecto.data.fechaEntrega = data.fechaEntrega
      this.isEditarProyecto.data.inmobiliaria = data.inmobiliaria
      this.isEditarProyecto.data.constructora = data.constructora
      this.isEditarProyecto.data.proveedorActual = data.proveedorActual
      this.isEditarProyecto.data.comments = data.comments
      this.isEditarProyecto.data.comment = ''
      this.isEditarProyecto.status = true
      this.showRegistroProyecto = true
      this.isEditarProyecto.title = 'EDITAR PROYECTO'
    },
    onActualizarTable() {
      this.getProyectos()
    },
    validarProyecto() {
      this.$refs.validateProyect.open()
    },
    chargeEmptyProject() {
      this.dialogGps = true
      this.$getLocation().then(coordinates => {
        this.dialogGps = false
        this.isEditarProyecto.data.codigo = ''
        this.isEditarProyecto.data.latitud = coordinates.lat
        this.isEditarProyecto.data.longitud = coordinates.lng
        this.isEditarProyecto.data.nombre = ''
        this.isEditarProyecto.data.direccion = ''
        this.isEditarProyecto.data.region = ''
        this.isEditarProyecto.data.provincia = ''
        this.isEditarProyecto.data.tipo = ''
        this.isEditarProyecto.data.categoria = ''
        this.isEditarProyecto.data.estado = ''
        this.isEditarProyecto.data.numeroPisos = ''
        this.isEditarProyecto.data.numeroDepartamentos = ''
        this.isEditarProyecto.data.etapa = ''
        this.isEditarProyecto.data.fechaEntrega = ''
        this.isEditarProyecto.data.inmobiliaria = ''
        this.isEditarProyecto.data.constructora = ''
        this.isEditarProyecto.data.proveedorActual = ''
        this.isEditarProyecto.status = false
        this.showRegistroProyecto = true
        this.isEditarProyecto.title = 'CREAR PROYECTO'
      })
    },
    modalUploadExcel() {
      this.showUpload = true
    },
    uploadFile() {
      this.isLoadinguploadFile = true
      var fileNameStorage = Math.random(30) + '.xlsx'
      var ref = firebase.storage().ref('archivos').child(fileNameStorage)
      var file = document.getElementById('file').files[0]
      var uploadTask = ref.put(file)
      uploadTask.on('state_changed', function (snapshot) {
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED:
            break
          case firebase.storage.TaskState.RUNNING:
            break
        }
      }, function () {
      }, function () {
      })
      var reader = new FileReader()
      if (file.name.split('.').pop() === 'xlsx' || file.name.split('.').pop() === 'xls') {
        reader.onload = e => {
          var data = new Uint8Array(e.target.result)
          var workbook = XLSX.read(data, { type: 'array' })
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          if (sheetName === 'Data') {
            this.items = XLSX.utils.sheet_to_json(worksheet, { raw: true, defval: '' })
            var length = this.items.length
            var i = 0
            this.items.forEach(item => {
              if (!item['CÓDIGO']) {
                i++
                alert('Existen proyectos sin código, estos no se cargarán al sistema')
              } else {
                if (item.CONSTRUYE) {
                  db.collection('contacts').doc(item.CONSTRUYE).set({
                    type: 1,
                    status: true,
                  }, { merge: true })
                }
                if (item.PROPIETARIO) {
                  db.collection('contacts').doc(item.PROPIETARIO).set({
                    type: 2,
                    status: true,
                  }, { merge: true })
                }
                db.collection('proyectos').doc(item['CÓDIGO'].toUpperCase().replace("'", '')).set({
                  latitud: item.LATITUD,
                  longitud: item.LONGITUD,
                  region: item.REGION.toUpperCase(),
                  provincia: item.PROVINCIA.toUpperCase(),
                  codigo: item['CÓDIGO'].toUpperCase().replace("'", ''),
                  categoria: item['CATEGORÍA'].toUpperCase(),
                  tipo: item['TIPO DE OBRA'].toUpperCase(),
                  constructora: item.PROPIETARIO.toUpperCase(),
                  inmobiliaria: item.CONSTRUYE.toUpperCase(),
                  direccion: item['DIRECCIÓN'].toUpperCase(),
                  nombre: item.PROYECTO.toUpperCase(),
                  prospector: item.PROSPECTOR,
                  asesor: item.ASESOR,
                  estadoNegociacion: item['ESTADO NEGOCIACION'].toUpperCase(),
                  tipoCliente: item['TIPO CLIENTE'].toUpperCase(),
                  proveedorActual: item['PROVEEDOR ACTUAL'].toUpperCase(),
                  proveedorActualAgrupado: item['PROVEEDOR ACTUAL AGRUPADO'].toUpperCase(),
                  etapa: item.ETAPA.toUpperCase(),
                  numeroPisos: parseInt(item.PISOS),
                  numeroDepartamentos: parseInt(item.DEPARTAMENTOS),
                  rangoVivienda: item['RANGO VIVIENDA'].toUpperCase(),
                  anio: item['AÑO'],
                  entrega: item.ENTREGA.toString().replace("'", ''),
                  foto: item.FOTO,
                  planos: 'no',
                  metrados: 'no',
                  fase: 1,
                  estado: true,
                  vendedor: {
                    nombre: '',
                  },
                  fechaEntrega: '',
                  fechaCreacion: firebase.firestore.Timestamp.fromDate(new Date()),
                  fechaEdicion: '',
                  dateFechaCotizacion: null,
                  dateFechaFacturacion: null,
                  tipoVivienda: null,
                  ipv: null,
                  cantidadPuertas: 0,
                  montoCerraduras: 0,
                  montoPuertas: 0,
                  montoCortafuego: 0,
                  reunion: '',
                  tipoSistema: null,
                  medioContacto: null,
                  posibilidadCierre: 0,
                  quienGano: '',
                  razonPerdido: '',
                }).then(() => {
                  this.progressUploadFile = (i / length) * 100
                  i++
                  if (i === length) {
                    this.showUpload = false
                    this.getProyectos()
                    this.isLoadinguploadFile = false
                  }
                })
              }
            })
          } else {
            alert('Errror en excel')
            this.isValid_file = false
          }
        }
        reader.readAsArrayBuffer(file)
      } else {
        this.isValid_file = true
        this.error_file = 'Este archivo no es un Excel.'
      }
    },
    previewFiles(e) {
      this.fileUploading = true
      var file = e
      var reader = new FileReader()
      if (file.name.split('.').pop() === 'xlsx' || file.name.split('.').pop() === 'xls') {
        reader.onload = e => {
          this.fileUploading = false
          var data = new Uint8Array(e.target.result)
          var workbook = XLSX.read(data, { type: 'array' })
          const sheetName = workbook.SheetNames[1]
          if (sheetName !== 'Data') {
            this.isValid_file = false
            this.error_file = 'Este archivo Excel es incorrecto.'
          } else {
            this.isValid_file = true
            this.error_file = ''
          }
        }
      } else {
        this.isValid_file = true
        this.error_file = 'Este archivo no es un Excel.'
      }
    },
    formatoFecha() {
      const fecha = new Date()
      const formato = 'dd/mm/yy'
      const map = {
        dd: fecha.getDate(),
        mm: fecha.getMonth() + 1,
        yy: fecha.getFullYear().toString().slice(-2),
        yyyy: fecha.getFullYear(),
      }
      const date = formato.replace(/dd|mm|yy|yyy/gi, matched => map[matched])
      return date + ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds()
    },
    downloadTemplate() {
      const worksheetData = [
        {
          "CÓDIGO": "",
          "LATITUD": "",
          "LONGITUD": "",
          "REGION": "",
          "PROVINCIA": "",
          "CATEGORÍA": "",
          "TIPO DE OBRA": "",
          "DIRECCIÓN": "",
          "PROYECTO": "",
          "PROSPECTOR": "",
          "ASESOR": "",
          "ESTADO NEGOCIACION": "",
          "TIPO CLIENTE": "",
          "PROVEEDOR ACTUAL": "",
          "PROVEEDOR ACTUAL AGRUPADO": "",
          "ETAPA": "",
          "PISOS": "",
          "DEPARTAMENTOS": "",
          "RANGO VIVIENDA": "",
          "AÑO": "",
          "ENTREGA": "",
          "FOTO": "",
          "CONSTRUYE": "",
          "PROPIETARIO": "",
        }
      ]
      const worksheet = XLSX.utils.json_to_sheet(worksheetData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "Plantilla Contactos")
      XLSX.writeFile(workbook, "Formato_Prospectos.xlsx")
    },
    },
  }
</script>
